import { render, staticRenderFns } from "./MainPropertyRow.vue?vue&type=template&id=9177fdd6&scoped=true&"
import script from "./MainPropertyRow.vue?vue&type=script&lang=js&"
export * from "./MainPropertyRow.vue?vue&type=script&lang=js&"
import style0 from "./MainPropertyRow.vue?vue&type=style&index=0&id=9177fdd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9177fdd6",
  null
  
)

export default component.exports